import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import StationUserInfo, { IStationUserViewPaneParams } from '../../components/station-user/view/StationUserInfo'
import { getOrganization } from '../../state/selectors'
import { IStoreState, IStationUserSearchObject } from '../../types'
import { moveToArchive, fetchStationUser } from '../../state/actions/station-user/index'
import { recoverPassword } from 'src/state/actions/auth'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  const { match, stationUser } = ownProps
  const organization = stationUser && getOrganization(stationUser.organizationId, state)
  return {
    stationUser,
    organizationName: (organization && organization.name) || '',
    isFetching: state.teamMember.isFetching,
    error: state.teamMember.error
  }
}

const mapDispatchToProps = (dispatch: any, props: RouteComponentProps<IStationUserViewPaneParams>) => {
  return {
    onResetClick: (teamMember: IStationUserSearchObject) => {
      return dispatch(recoverPassword(teamMember.email))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StationUserInfo)



// WEBPACK FOOTER //
// ./src/containers/station-user/StationUserInfo.ts